import EtrackerTracking from 'PyzShopUi/scripts/etracker/EtrackerTracking';
import {EtrackerEventNames, IEtrackerProduct} from 'PyzShopUi/scripts/etracker/IEtrackerTracking';
import Utils from 'PyzShopUi/scripts/utils/utils';

export default class Event {
    public static init() {
        const removeWatchListButtons: NodeListOf<HTMLElement> = document.querySelectorAll('[data-etrack-action]');
        removeWatchListButtons.forEach((button) => {
            const buttonData = button.dataset;

            switch(buttonData.etrackAction) {
                case EtrackerEventNames.REMOVE_FROM_WATCH_LIST:
                    button.addEventListener('click', function() {
                        EtrackerTracking.removeFromWatchlist(JSON.parse(buttonData.etrackerProduct))
                    })
                    break;
                case EtrackerEventNames.INSERT_TO_WATCH_LIST:
                    button.addEventListener('click', function() {
                        EtrackerTracking.insertToWatchlist(JSON.parse(buttonData.etrackerProduct))
                    })
                    break;
                case EtrackerEventNames.INSERT_TO_BASKET:
                    button.addEventListener('click', function() {
                        EtrackerTracking.insertToBasket(JSON.parse(buttonData.etrackerProduct), 1)
                    })
                    break;
                case EtrackerEventNames.REMOVE_FROM_BASKET:
                    button.addEventListener('click', function() {
                        EtrackerTracking.removeFromBasket(JSON.parse(buttonData.etrackerProduct))
                    })
                    break;
            }
        })
    }
}
